exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pay-content[data-v-7358d996] {\n  padding: 0.4rem 0.666667rem;\n  text-align: left;\n}\n.pay-content .pay-info[data-v-7358d996] {\n  font-size: 0.373333rem;\n}\n.pay-content .pay-info[data-v-7358d996] p {\n  margin-bottom: 0.133333rem;\n  position: relative;\n  padding-left: 0.266667rem;\n}\n.pay-content .pay-info[data-v-7358d996] p:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  font-size: 0.4rem;\n  top: 0;\n}\n.pay-content .pay-btn[data-v-7358d996] {\n  width: 100%;\n  margin-top: 1.333333rem;\n}", ""]);

// exports
